import type { LazyImageProps } from "@dmm-com/rocket-web-ui-library/es6/components/lazy-image";
import { memo } from "react";
import * as Styled from "./style";

const IMAGE_WIDTH = 1920;
const IMAGE_HEIGHT = 1080;

// HACK: LazyImageを使っていないのに、LazyImageの型を使っているのはよろしくない & LazyImageを使うようにしたい
type SampleVisualImageProps = Pick<LazyImageProps, "src" | "alt" | "alternativeSrc">;

/** アスペクト比が「16:9」または「4:3」のkeyVisual画像を「16:9」で表示するために使用するコンポーネント */
export const SampleVisualImage = memo((props: SampleVisualImageProps) => {
  const { src, alt, alternativeSrc } = props;

  // HACK: LazyImageを使うようにしたい
  return (
    <Styled.DivSampleImageWrapper>
      <Styled.PictureSampleImagePosition>
        <source srcSet={src} type="image/webp" />
        <Styled.CustomImage src={alternativeSrc} alt={alt} width={IMAGE_WIDTH} height={IMAGE_HEIGHT} />
      </Styled.PictureSampleImagePosition>
    </Styled.DivSampleImageWrapper>
  );
});

SampleVisualImage.displayName = "SampleVisualImage";
